import React from 'react';
import PropTypes from 'prop-types';
import {useAppStore} from '@/page/app/context';
import {NotAuthorityView} from '@/component';

AppAuthRoute.propTypes = {
    /**
     * 是否只有应用管理员可访问
     */
    needMgr: PropTypes.bool,
    children: PropTypes.node,
};

function AppAuthRoute({needMgr = false, children}) {
    const [{isMgr}] = useAppStore();

    // 管理员方可访问
    if (needMgr && !isMgr) {
        return <NotAuthorityView />;
    }
    return children;
}

export default AppAuthRoute;
